import {Component} from "@angular/core";
import {CodeRole} from "../interfaces/user.interface";

@Component({
    template: '',
})
export abstract class GenesisComponent {

    protected userCompany: string;
    userRole: string;

    protected initUserEnv() {
        this.userRole = localStorage.getItem("role");
        if (this.userRole !== CodeRole.SUPERADMIN) {
            this.userCompany = localStorage.getItem("company");
        }
    }

    public isSuperAdmin() {
        return this.userRole === CodeRole.SUPERADMIN
    }

    public isAdministration() {
        return this.userRole === CodeRole.ADMINISTRATION
    }

    public canHandleCompany() {
        return this.isSuperAdmin() || this.isAdministration()
        // return false // sometime used for fast ui tests....
    }

}